"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class ProductCategory {
  static thaw(productCategoryObj) {
    if (productCategoryObj == null) return null;
    const productCategory = new ProductCategory();
    if (productCategoryObj.id != null) productCategory.setId(productCategoryObj.id);
    if (productCategoryObj.name != null) productCategory.setName(productCategoryObj.name);
    if (productCategoryObj.displayImageUrl != null) productCategory.setDisplayImageUrl(productCategoryObj.displayImageUrl);
    if (productCategoryObj.singularName != null) productCategory.setSingularName(productCategoryObj.singularName);
    if (productCategoryObj.isActive != null) productCategory.setIsActive(productCategoryObj.isActive == null ? null : productCategoryObj.isActive ? true : false);
    if (productCategoryObj.products != null) productCategory.setProducts(_.Product.thawList(productCategoryObj.products));
    return productCategory;
  }

  static thawList(productCategoryObjList) {
    if (productCategoryObjList == null) return [];
    var productCategorys = [];

    for (var i = 0; i < productCategoryObjList.length; i++) {
      productCategorys.push(ProductCategory.thaw(productCategoryObjList[i]));
    }

    return productCategorys;
  }

  static freeze(productCategory) {
    if (productCategory == null) return null;
    var productCategoryObj = {};
    if (productCategory.getId() != null) productCategoryObj.id = productCategory.getId();
    if (productCategory.getName() != null) productCategoryObj.name = productCategory.getName();
    if (productCategory.getDisplayImageUrl() != null) productCategoryObj.displayImageUrl = productCategory.getDisplayImageUrl();
    if (productCategory.getSingularName() != null) productCategoryObj.singularName = productCategory.getSingularName();
    if (productCategory.getIsActive() != null) productCategoryObj.isActive = productCategory.getIsActive() == null ? null : productCategory.getIsActive() ? 1 : 0;
    if (productCategory.getProducts() != null) productCategoryObj.products = _.Product.freezeList(productCategory.getProducts());
    return productCategoryObj;
  }

  static freezeList(productCategorys) {
    if (productCategorys == null) return [];
    var productCategoryObjList = [];

    for (var i = 0; i < productCategorys.length; i++) {
      productCategoryObjList.push(ProductCategory.freeze(productCategorys[i]));
    }

    return productCategoryObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setDisplayImageUrl(null);
    this.setSingularName(null);
    this.setIsActive(null);
    this.setProducts(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setDisplayImageUrl(displayImageUrl) {
    this.displayImageUrl = displayImageUrl;
  }

  setSingularName(singularName) {
    this.singularName = singularName;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setProducts(products) {
    this.products = products;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDisplayImageUrl() {
    return this.displayImageUrl;
  }

  getSingularName() {
    return this.singularName;
  }

  getIsActive() {
    return this.isActive;
  }

  getProducts() {
    return this.products;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = ProductCategory;